export enum PackagingPart {
    System,
    Unit,
    Component,
    Material
}
